import React, { useContext, useEffect, useState } from 'react';

import Modal from 'react-bootstrap/Modal';
import { Heading } from '@/components/Elements/Heading';
import { Button } from '@/components/Elements';
import { default as ReactSelect, components } from 'react-select';

import { showNotification } from '@/utils/notificationUtils';
import './LinkSubscription.scss';
import { ReactComponent as MenuBackIcon } from '@/assets/img/menu-back-icon.svg';
import { UserContext } from '@/routes';
import { Subscriber } from '../types';
import { useGetBusinessNotSubscribed } from '../api/getBusiness';
import { Business } from '@/features/business';
import { useLinkSubscriber } from '../api/linkSubscription';

type LinkSubscriptionProps = {
  open: boolean;
  subscription: Subscriber;
  onClose: (refresh: boolean) => void;
};
const perPage = 100;

const LinkSubscription = ({ open, onClose, subscription }: LinkSubscriptionProps) => {
  const userContext = useContext(UserContext);
  const useGetBusinessMutation = useGetBusinessNotSubscribed();
  const linkSubscriberMutation = useLinkSubscriber();
  const [businesses, setBusinesses] = useState<Business[]>();
  const [selectedBusiness, setSelectedBusiness] = useState<Business>();

  useEffect(() => {
    window.scrollTo(0, 0);
    getBusiness();
  }, []);

  const getBusiness = async () => {
    const res = await useGetBusinessMutation.mutateAsync({});
    setBusinesses(res.list);
  };

  const getContent = () => {
    return (
      <div className="link-subscription">
        <label>Subscriber Details</label>
        <div className="details">
          <span className="key">Name</span>
          <span className="data">{subscription.name}</span>
        </div>
        <div className="details">
          <span className="key">Email</span>
          <span className="data">{subscription.email}</span>
        </div>
        <div className="details">
          <span className="key">Phone</span>
          <span className="data">{subscription.phone}</span>
        </div>
        <div className="details">
          <span className="key">Selected Plan</span>
          <span className="data">Petsked Premium</span>
        </div>
        <div className="details">
          <span className="key">Status</span>
          <span className="data">{subscription.status}</span>
        </div>
        {/* <label>Link to the business</label>
        <div className="details">
          <div className="petsked-form form-field mt-3 mb-4">
            <ReactSelect
              className="multiselect-react"
              options={businesses ? businesses : []}
              isMulti={false}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              classNamePrefix={'petsked-multiselect'}
              onChange={(selected: any) => {
                setSelectedBusiness(selected);
              }}
              getOptionLabel={(option: any) => option.name}
              getOptionValue={(option: any) => option.id}
              placeholder={'Select Business to link'}
              value={selectedBusiness}
              components={{
                Option,
              }}
            />
          </div>
        </div> */}
        {subscription && subscription?.subscription && subscription?.subscription?.business ? (
          <div className="details">
            <span className="key">Link to business</span>
            <span className="data">{subscription?.subscription?.business?.name}</span>
          </div>
        ) : (
          <>
            {' '}
            <label>Link to the business</label>
            <div className="details">
              <div className="petsked-form form-field mt-3 mb-4">
                <ReactSelect
                  className="multiselect-react"
                  options={businesses ? businesses : []}
                  isMulti={false}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  classNamePrefix={'petsked-multiselect'}
                  onChange={(selected: any) => {
                    setSelectedBusiness(selected);
                  }}
                  getOptionLabel={(option: any) => option.name}
                  getOptionValue={(option: any) => option.id}
                  placeholder={'Select Business to link'}
                  value={selectedBusiness}
                  components={{
                    Option,
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  };
  const linkSubscription = async () => {
    if (selectedBusiness && subscription) {
      await linkSubscriberMutation.mutateAsync({
        businessId: selectedBusiness?.id,
        subscriberId: subscription?.id,
      });
      onClose(true);
    } else {
      showNotification({ type: 'error', title: 'Please select the business to link' });
    }
  };
  return (
    <>
      {userContext?.isLandscape ? (
        <Modal
          show={open}
          onHide={() => onClose(false)}
          className="petsked-modal-dialog  edit-member-dialog"
        >
          <Modal.Header closeButton>
            <Heading size="lg" title="Link Subscription" />
          </Modal.Header>

          <Modal.Body>{getContent()}</Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              size="lg"
              onClick={linkSubscription}
              disabled={
                subscription && subscription?.subscription && subscription?.subscription?.business
              }
            >
              {subscription && subscription?.subscription && subscription?.subscription?.business
                ? 'Linked'
                : 'Link Subscription'}
            </Button>
          </Modal.Footer>
        </Modal>
      ) : (
        <>
          <div className="edit-member-mobile">
            <div
              className="menu-back-nav"
              onClick={() => {
                onClose(false);
              }}
            >
              <MenuBackIcon /> <span>Back</span>
            </div>
            <Heading
              size="lg"
              title="Edit member details"
              description="Update the details of your team member below"
            />
            {getContent()}
            <div className="action">
              <Button variant="primary" size="lg" onClick={linkSubscription}>
                Link Subscription
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};
const Option = (props: any) => {
  const {
    data: { avatarUrl, name, email, users },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option flex items-center justify-between">
          <div className="items-center">
            <label className="name">{name}</label>
            {/* <p className="name">{users && users[0].email}</p> */}
          </div>
        </div>
      </components.Option>
    </div>
  );
};

const ValueContainer = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Add Services</span>}
      {valueLength > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} Service${valueLength != 1 ? 's' : ''} added`}
      {React.Children.map(props.children, (child) => {
        return child && child.type === components.Input ? child : null;
      })}
    </components.ValueContainer>
  );
};
export default LinkSubscription;
